import { isInvoiceRoutesPath } from 'Invoices/invoices.router'
import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const useCloseInvoiceEditor = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [previouslyClosedInvoice, setPreviouslyClosedInvoice] =
    useState<string>()

  /**
   * If we have closed the invoice and are now viewing another invoice, go
   * to the invoices root path.
   */
  useEffect(() => {
    if (previouslyClosedInvoice && isInvoiceRoutesPath(location.pathname)) {
      navigate('/invoices')
    }
  }, [location, navigate, previouslyClosedInvoice])

  return useCallback(() => {
    /**
     * The browsers 'new tab' page counts as an entry in window.history, so requiring at least 3 pages means that
     * there is somewhere valid in the dashboard we can navigate back to. If there isn't (e.g. opening a new tab
     * and going straight to /invoices/new), then default to the invoices root path.
     */
    setPreviouslyClosedInvoice(location.pathname)
    if (window.history.length >= 3) {
      navigate(-1)
    } else {
      navigate('/invoices')
    }
  }, [navigate, location.pathname])
}
